/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetCrmCategoryIdsForTefanawwal Input Action
 */
export class GetCrmCategoryIdsForTefanawwalInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string | undefined;
    constructor(token : string | undefined) {
        this.token = token;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CRMCATEGORYIDS`;
    public getCacheObjectType = () => 'CRMCATEGORYIDS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCrmCategoryIdsForTefanawwalData {
    szf_tefanalawwalcategoryid: string;
    szf_hqid: string;
    szf_name: string;
    szf_arabicname: string;

}
export interface IGetTefanCategoryOptionsData {
    status: boolean,
    data: IGetCrmCategoryIdsForTefanawwalData[] | undefined,
}
/**
 * TODO: Use this function to create the input required to make the action call
 */
const createCategoryIdsInput = (args: Msdyn365.ICreateActionContext, token: string): Msdyn365.IActionInput => {
    return new GetCrmCategoryIdsForTefanawwalInput(token);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function categoryIdsDataAction(input: GetCrmCategoryIdsForTefanawwalInput, ctx: Msdyn365.IActionContext): Promise<IGetTefanCategoryOptionsData> {
    const token = input.token;
    const szfCRMDomainForTefanAwwal = ctx.requestContext.app.config.szfCRMDomainForTefanAwwal;

    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomainForTefanAwwal}/api/data/v9.1/szf_tefanalawwalcategories?$select=szf_tefanalawwalcategoryid,szf_name,szf_arabicname`, "get", {}, {
        headers: {
            'Authorization':`Bearer ${token}`
        }
    });
    if(response && response.data && response.data.value && response.data.value.length > 0){
        return {
            status: true,
            data: response.data.value
        };
    }else{
        return {
            status: false,
            data: undefined
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetTefanCategoryOptionsData>>categoryIdsDataAction,
    // TODO: Give your data action a unique id
    id: 'GetCrmCategoryIdsForTefanawwal',
    input: createCategoryIdsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
